import { ExpediaBannerLinkConfig } from './expedia-link.config';

export const BannerLinkConfig = {
  ...ExpediaBannerLinkConfig,
};
